module.exports = __webpack_public_path__ + "static/media/IKMS10.9d4c3923.jpg";